export class AddACCResultDto {
    accId: number;
}
